import type {
  DatasourceAuthState,
  DatasourceOneTimeState,
} from "@superblocksteam/shared";

type OAuthRedirectState = Partial<DatasourceAuthState & DatasourceOneTimeState>;

export function encodeOAuthRedirectState(state: OAuthRedirectState): string {
  const {
    authConfig,
    authId,
    authType,
    configurationId,
    externalUser,
    integrationId,
    oneTimeCode,
    openerOrigin,
    origin,
    pluginId,
    profileKey,
    useLocalStorage,
  } = state;
  const redirectState = {
    ...(authConfig
      ? {
          authConfig: {
            authorizationUrl: authConfig.authorizationUrl,
            clientAuthMethod: authConfig.clientAuthMethod,
            clientId: authConfig.clientId,
            refreshTokenFromServer: authConfig.refreshTokenFromServer,
            scope: authConfig.scope,
            tokenScope: authConfig.tokenScope,
            tokenUrl: authConfig.tokenUrl,
            usePkce: authConfig.usePkce,
            usePkceClientSecret: authConfig.usePkceClientSecret,
            userInfoUrl: authConfig.userInfoUrl,
          },
        }
      : {}),
    ...(authId ? { authId } : {}),
    ...(authType ? { authType } : {}),
    ...(configurationId ? { configurationId } : {}),
    ...(externalUser !== undefined ? { externalUser } : {}),
    ...(integrationId ? { integrationId } : {}),
    ...(oneTimeCode ? { oneTimeCode } : {}),
    ...(openerOrigin ? { openerOrigin } : {}),
    ...(origin ? { origin } : {}),
    ...(pluginId ? { pluginId } : {}),
    ...(profileKey ? { profileKey } : {}),
    ...(useLocalStorage !== undefined ? { useLocalStorage } : {}),
  };

  return Buffer.from(JSON.stringify(redirectState), "utf8").toString("base64");
}
